import React, { useState, useEffect } from 'react';

const EmailUpdatePopup = () => {
  const [isOpen, setIsOpen] = useState(false); // Start closed to implement delay
  const [shouldShow, setShouldShow] = useState(true);

  useEffect(() => {
    // Check if the popup has been closed before
    // const popupClosed = localStorage.getItem('emailPopupClosed'); // Removed as it's unused
    const closedDate = localStorage.getItem('emailPopupClosedDate');
    
    // If closed date exists, check if it's been less than 10 days
    if (closedDate) {
      const daysSinceClosed = (new Date() - new Date(closedDate)) / (1000 * 60 * 60 * 24);
      if (daysSinceClosed < 10) {
        setShouldShow(false);
        return;
      }
    }

    // If popup was previously closed or we have no record, prepare to show it
    setShouldShow(false); // Changed from popupClosed !== 'true' to always be false
  }, []);

  // Add delay effect
  useEffect(() => {
    if (shouldShow) {
      const timer = setTimeout(() => {
        setIsOpen(true);
      }, 1000); // 1-second delay
      
      return () => clearTimeout(timer); // Cleanup timer
    }
  }, [shouldShow]);

  const closePopup = () => {
    setIsOpen(false);
    // Keep showing state true, let localStorage handle reopening logic
    // localStorage.setItem('emailPopupClosed', 'true'); // Let animation finish before potentially removing
    // localStorage.setItem('emailPopupClosedDate', new Date().toISOString());
    
    // Add timeout to allow animation before setting local storage and truly hiding
    setTimeout(() => {
        localStorage.setItem('emailPopupClosed', 'true');
        localStorage.setItem('emailPopupClosedDate', new Date().toISOString());
        // Optionally force a state update if needed, though conditional rendering should handle it
        // setShouldShow(false); // Might not be necessary if parent rerenders or component unmounts
    }, 300); // Match transition duration
  };

  const handleOverlayKeyPress = (event) => {
    if (event.key === 'Enter' || event.key === ' ') {
      closePopup();
    }
  };

  // Render the container even when isOpen is false to allow for exit animation
  if (!shouldShow) return null; 

  return (
    <div className={`fixed inset-0 z-50 flex items-center justify-center transition-opacity duration-300 ${isOpen ? 'opacity-100' : 'opacity-0 pointer-events-none'}`}>
      {/* Overlay */}
      <div
        className="absolute inset-0 bg-black bg-opacity-75"
        onClick={closePopup}
        onKeyPress={handleOverlayKeyPress}
        role="button"
        tabIndex={0}
      />
      
      {/* Popup content - add transition classes */}
      <div 
        className={`relative w-3/5 sm:w-2/5 md:w-1/3 lg:w-1/5 mx-auto transform transition-all duration-300 ease-out ${isOpen ? 'scale-100 opacity-100' : 'scale-95 opacity-0'}`}
      >
        <img 
          src="/novidade_mirante.webp" 
          alt="Novo mirante do Jardim da Amazônia" 
          className="w-full h-auto rounded-lg shadow-xl"
        />
        
        {/* Prominent X button */}
        <button 
          type="button"
          onClick={closePopup}
          className="absolute top-2 right-2 bg-black bg-opacity-50 hover:bg-opacity-70 text-white rounded-full p-2 transition-all"
          aria-label="Close"
          style={{ width: '28px', height: '28px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
        >
          <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <title>Close icon</title>
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>
    </div>
  );
};

export default EmailUpdatePopup; 